import Bowser from 'bowser';

import uaTypes from '../consts/uaTypes';

const parser = Bowser.getParser(navigator.userAgent);

const getOSName = () => parser.getOSName(true);
const getOSVersion = () => parser.getOSVersion();
const getDeviceType = () => parser.getPlatformType(true);
const getBrowserName = () => parser.getBrowserName(true);

const getIsIOS = () => parser.isOS(uaTypes.IOS);
const getIsAndroid = () => parser.isOS(uaTypes.ANDROID);
const getIsMacOS = () => parser.isOS(uaTypes.MACOS);

const getIsSafari = () => parser.isBrowser(uaTypes.SAFARI);
const getIsChrome = () => parser.isBrowser(uaTypes.CHROME);

const getIsDesktop = () => parser.isPlatform(uaTypes.DESKTOP);
const getIsTablet = () => parser.isPlatform(uaTypes.TABLET) || getIsIPad();
const getIsMobile = () => parser.isPlatform(uaTypes.MOBILE);

// iPadOS 13+ (released Sep 2019) reports as macOS in user agent
// Pre-iPadOS devices (iOS 12 and earlier on iPad) correctly report as iOS with tablet platform
const getIsIPad = () => {
    const isMacOS = getIsMacOS();
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // If it's macOS with touch support - likely iPad
    return isMacOS && isTouchDevice;
};

const checkIOSSafariVersion = (version) => parser.satisfies({ios: {safari: version}}); // Ex: version = '>=26'

const checkIsIOSSafari26 = () => checkIOSSafariVersion('>=26');

const checkIsIOSSafari26_1 = () => checkIOSSafariVersion('=26.1');

const checkIsIOSSafari27 = () => checkIOSSafariVersion('>=27');

export default {
    getBrowserName,
    getOSName,
    getOSVersion,
    getDeviceType,
    getIsIOS,
    getIsAndroid,
    getIsSafari,
    getIsChrome,
    getIsDesktop,
    getIsTablet,
    getIsMobile,
    checkIOSSafariVersion,
    checkIsIOSSafari26,
    checkIsIOSSafari26_1,
    checkIsIOSSafari27,
};
